import AutospinSettingsPartContainer from "@baseUI/component/settings/AutospinSettingsPartContainer";
import UIFacade from "@baseUI/UIFacade";

export default class AutospinSettingsPartContainerPortrait extends AutospinSettingsPartContainer {

    constructor(params) {
        super(params)
        this.init()
    }

    setParametersSizePosition(params){

        const startAutoplayX = 230 - 90 * (UIFacade.model.autospinList.length - 3)
        this.param = {
            panelPopupPosition: {x: 0, y: 0},
            popupAutoplayCaptionPosition: params.captionPosition,
            lineTop: {x1: 30, y1: 100, x2: 930, y2: 100},
            lineMiddle: {x1: 30, y1: 460, x2: 930, y2: 460},

            panelAdditionalPosition: {x: 80, y: 150},
            createPartCountNumbers: 7,
            countNumbers: { btn: {width : 140, height: 120, spaceX: 30, spaceY: 50, startX: startAutoplayX, startY: 140}},
            popupAutoplayRoundsPosition:[400, 0],
            panelBalance: {x: 0, y: 310},
            balanceLower: { btn: {width : 180, height: 100, spaceX: 20, spaceY: 180, startX: 200, startY: 240}},
            balanceHigher: { btn: {width : 180, height: 100, spaceX: 20, spaceY: 180, startX: 200, startY: 520}},
            popupAutoplaySettingsPosition: [400,44],
            popupAutoplayLowerPosition: [380,120],
            popupAutoplayHigherPosition: [380,400],
            settingPlayPosition:[480, 1140]
        }
    }

}
